var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPicoColored = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 13,
    viewBox: "0 0 96 96",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48,0A48,48,0,1,0,96,48,48,48,0,0,0,48,0Zm0,87A39,39,0,0,1,9.39,42.54C13.92,37.57,21.52,31,30,31c19.63,0,31.85,26.77,54.87,29.72A39,39,0,0,1,48,87ZM30,22a26.65,26.65,0,0,0-14.23,4A39,39,0,0,1,86.69,52.86C67.1,50.71,53,22,30,22ZM22,49a6,6,0,1,0,6-6A6,6,0,0,0,22,49Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPicoColored);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-pico-colored.a2246114c364a368e5b3f5068b1f9c00.svg";